import {get,post} from '@/util/http';
import { Notification } from 'uiv'

const exhibitor = {
    state:{},
    mutations:{},
    actions:{
        async planning({},params){//展馆规划
            const res = await get('/CifitSystem/api/exhibitor/pavilion/planning.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async actorlist({},params){//展商一览列表接口
            const res = await get('/CifitSystem/api/exhibitor/actorQuery/actorlist.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getActorInfo({},params){//展商详情信息
            const res = await get('/CifitSystem/api/exhibitor/actorQuery/getActorInfo.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getList({},params){//展品运输指南，一级接口
            const res = await get('/CifitSystem/api/exhibitor/transportGuide/getList.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async merchantsList({},params){//参展客商情况
            const res = await get('/CifitSystem/api/exhibitor/merchantsSituation/getList.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async getBoothArea({},params){//获取展区列表
            const res = await get('/CifitSystem/api/exhibitor/actorQuery/getBoothArea.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
        async actorQuery({},params){//分页查询展商信息
            const res = await get('/CifitSystem/api/exhibitor/actorQuery/findactor.jhtml',params);
            // return res.code == 200 ? res.data : false;
            if(res.code == 200){
                return res.data
            }else{
                Notification.notify({
                    type: 'danger',
                    title: '提示',
                    content: res.message,
                    duration: 0,
                    placement: 'bottom-right',
                })
            }
        },
    }
}

export default exhibitor


// WEBPACK FOOTER //
// ./src/store/modules/exhibitor.js